import { connect } from "react-redux";
import { requestGetTasksByClaimId } from "../../../../store/data/thunks";
import { State } from "../../../../store/state";

import Overview from "./Overview";

const mapStateToProps = (state: State) => ({
  tasks: state.data.tasks
});

const mapDispatchToProps = {
  requestGetTasksByClaimId
};

const OverviewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Overview);

export default OverviewContainer;
